import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IPagedData, PagedCrudService } from "@features/grid";
import {
    DashboardQueryPageRequest,
    IDashboardQueryBuild,
    IDashboardQueryMinimal,
    IDashboardQueryView
} from "@main/reporting.v3/dashboard/dashboard-models";
import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";


@Injectable()
export class DashboardQueryService extends PagedCrudService<IDashboardQueryBuild> {
    readonly url = "api/reporting3/dashboard-query";
    readonly entityTitle = "Dashboard Query";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    getPageByDashboardId(dashboardId: string, request: DashboardQueryPageRequest): Promise<IPagedData<IDashboardQueryView>> {
        return this.handle<IPagedData<IDashboardQueryView>>(
            this.http.get<IPagedData<IDashboardQueryView>>(`${this.url}/${dashboardId}/page`,
                { params: this.constructHttpParams(request) }))
    }

    getAllByDashboardId(dashboardId: string, request: DashboardQueryPageRequest): Promise<IDashboardQueryMinimal[]> {
        return this.handle<IDashboardQueryMinimal[]>(
            this.http.get<IDashboardQueryMinimal[]>(`${this.url}/${dashboardId}/all`,
                { params: this.constructHttpParams(request) }))
    }

    getQueryByName(dashboardId: string, queryName: string): Promise<IDashboardQueryMinimal> {
        return this.httpGet<IDashboardQueryMinimal>(`${dashboardId}/${encodeURIComponent(queryName)}/preload`);
    }

    removeDashboardQueryDrafts(dashboardId: string): Promise<void> {
        return this.httpDelete(`${dashboardId}/drafts`);
    }
}